import type { ProductCatalogVariationFragment } from 'src/shared/graphql/generated';

export const getFacetValue = (
  variation: ProductCatalogVariationFragment,
  facetName: string,
) => {
  if (variation.variationFacets) {
    const foundFacet = variation.variationFacets.find(
      facet =>
        facet.facetValue?.facet.name === facetName ||
        facet.facetType === facetName,
    );
    return foundFacet?.facetValue?.value || foundFacet?.value;
  }

  return undefined;
};

export const isGenericProduct = (variation: ProductCatalogVariationFragment) =>
  !!(variation?.product.provider?.name ?? '').match('Generic');
